/**
 * Where the buyer collects an order (P25009-484 BR-4 / BR-8).
 *
 * Checkout printed "Upphämtningsplats: Okänd plats" because it read only the
 * listing's own `publicData.location`, which many listings do not have —
 * imported and supplier-feed listings among them. The seller's facilities
 * (the Address documents behind the Anläggningar page) do know the place, so
 * they are the fallback, in the order the rest of the app already uses: the
 * facility the listing names (`publicData.warehouse`, matched by title), the
 * seller's default facility, then their first one. The town alone is the last
 * resort; a place we cannot name gives null, never a made-up one.
 *
 * @param {Object} params
 * @param {Object} params.publicData the listing's publicData
 * @param {Array} [params.facilities] the seller's facilities (getAuthorWarehouses)
 * @returns {null|{ title: string|null, address: string, building: string|null }}
 */
export const pickupPlaceFor = ({ publicData = {}, facilities = [] }) => {
  const location = (publicData && publicData.location) || {};
  const list = (Array.isArray(facilities) ? facilities : []).filter(Boolean);
  const named = publicData?.warehouse ? list.find(f => f.title === publicData.warehouse) : null;
  const facility = named || list.find(f => f.isDefault) || list[0] || null;
  const facilityAddress = facility?.location?.selectedPlace?.address || null;

  if (location.address) {
    return {
      title: named?.title || null,
      address: location.address,
      building: location.building || null,
    };
  }
  if (facilityAddress) {
    return {
      title: facility.title || null,
      address: facilityAddress,
      building: facility.building || null,
    };
  }
  const city = publicData?.city || location.city || facility?.location?.city || null;
  return city ? { title: null, address: city, building: null } : null;
};

/** One line for the buyer: "Lager Syd, Industrivägen 4, Göteborg". */
export const pickupPlaceLine = place => {
  if (!place) return null;
  return [place.title, place.building, place.address].filter(Boolean).join(', ');
};
